export default (url, router) => {
  let res = false
  let subdominio = url.substr(url.indexOf('//') + 2, url.indexOf('.') - (url.indexOf('//') + 2))
  switch (subdominio) {
    case 'adm':
      res = true
      router.push('/enb/login')
      break;
  }
  return res
}
